import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  text: {
    marginTop: 30,
    width: 30,
    alignSelf: 'center'
  },
  customLocation: {
    marginTop: 30,
    width: '100%',
    height: 55
  }
})
